'use client';

import React from 'react';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { useCallback, useEffect, useRef, useState } from 'react';

import { motion, useAnimationControls } from 'framer-motion';
import { Paragraph } from '../ui/paragraph';
import { PriceOfferDialog } from '../ui/price-offer-dialog';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';

export function Topbar({
  generalLayout,
}: {
  locale?: string;
  generalLayout: GeneralLayout['data'];
}) {
  const speed = 50;

  const trackRef = useRef<HTMLDivElement>(null);
  const controls = useAnimationControls();
  const [trackWidth, setTrackWidth] = useState(0);
  const [isReducedMotion, setReducedMotion] = useState(false);

  const measure = useCallback(() => {
    if (!trackRef.current) return;
    const fourth = trackRef.current.scrollWidth / 4;
    setTrackWidth(fourth);
  }, []);

  useEffect(() => {
    measure();
    const handler = () => measure();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [measure]);

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(media.matches);

    const listener = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  useEffect(() => {
    if (!trackWidth || isReducedMotion) return;

    const duration = speed;

    controls.set({ x: 0 });
    controls.start({
      x: -trackWidth,
      transition: {
        duration,
        ease: 'linear',
        repeat: Infinity,
        repeatType: 'loop',
      },
    });
  }, [trackWidth, speed, controls, isReducedMotion]);

  return (
    <>
      <div
        id="topbar-desktop"
        className="hidden h-[36px] w-full items-center justify-center gap-2.5 bg-black sm:flex sm:h-10 lg:h-12"
      >
        <Paragraph color="white" size="md" innerHtml={generalLayout.header?.top_bar_text ?? ''} />
        <PriceOfferDialog>
          <Button
            variant={'none'}
            size={'none'}
            className={cn(
              'ea-topbar__price-offer-dialog',
              'font-semibold text-white transition-all hover:opacity-75',
            )}
          >
            CHCEM VÝHODNÚ PONUKU
          </Button>
        </PriceOfferDialog>
      </div>
      <div
        id="topbar-mobile"
        className="relative flex h-[36px] w-full items-center justify-center gap-2.5 overflow-hidden bg-black sm:hidden sm:h-10 lg:h-12"
      >
        <motion.div
          ref={trackRef}
          className="flex gap-2.5"
          style={{ willChange: 'transform' }}
          animate={controls}
        >
          <Paragraph
            color="white"
            size="md"
            innerHtml={generalLayout.header?.top_bar_text ?? ''}
            className="whitespace-nowrap"
          />
          <PriceOfferDialog>
            <Button
              variant={'none'}
              size={'none'}
              className={cn(
                'ea-topbar__price-offer-dialog',
                'whitespace-nowrap font-semibold text-white transition-all hover:opacity-75',
              )}
            >
              CHCEM VÝHODNÚ PONUKU
            </Button>
          </PriceOfferDialog>
          <Paragraph
            color="white"
            size="md"
            innerHtml={generalLayout.header?.top_bar_text ?? ''}
            className="whitespace-nowrap"
          />
          <PriceOfferDialog>
            <Button
              variant={'none'}
              size={'none'}
              className={cn(
                'ea-topbar__price-offer-dialog',
                'whitespace-nowrap font-semibold text-white transition-all hover:opacity-75',
              )}
            >
              CHCEM VÝHODNÚ PONUKU
            </Button>
          </PriceOfferDialog>
          <Paragraph
            color="white"
            size="md"
            innerHtml={generalLayout.header?.top_bar_text ?? ''}
            className="whitespace-nowrap"
          />
          <PriceOfferDialog>
            <Button
              variant={'none'}
              size={'none'}
              className={cn(
                'ea-topbar__price-offer-dialog',
                'whitespace-nowrap font-semibold text-white transition-all hover:opacity-75',
              )}
            >
              CHCEM VÝHODNÚ PONUKU
            </Button>
          </PriceOfferDialog>
          <Paragraph
            color="white"
            size="md"
            innerHtml={generalLayout.header?.top_bar_text ?? ''}
            className="whitespace-nowrap"
          />
          <PriceOfferDialog>
            <Button
              variant={'none'}
              size={'none'}
              className={cn(
                'ea-topbar__price-offer-dialog',
                'whitespace-nowrap font-semibold text-white transition-all hover:opacity-75',
              )}
            >
              CHCEM VÝHODNÚ PONUKU
            </Button>
          </PriceOfferDialog>
        </motion.div>
      </div>
    </>
  );
}
